import React from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";

export default function LabourReportSkippedsearch() {
  return (
    <Fragment>
      <div className="row customers ">
        <div className="col-sm-12 ">
          <h2>Labor Report </h2>
          <h6>Skipped Stops</h6>
        </div>
      </div>
    </Fragment>
  );
}
